import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { MatchHeaderTabBarComponent } from '../../components/match-tab-bar/match-tab-bar.component';
import { CompetitionMatchSummary, EMatchTap } from '../../models';
import {
  InformationComponent,
  LineupComponent,
  StatsComponent,
  SummaryComponent,
} from './tabs';
import { EGamePeriod } from '../../../enums';

@Component({
  selector: 'app-match',
  standalone: true,
  imports: [
    MatchHeaderTabBarComponent,
    SummaryComponent,
    StatsComponent,
    LineupComponent,
    InformationComponent,
  ],
  templateUrl: './match.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatchComponent {
  competition = input.required<CompetitionMatchSummary | null>();
  tsExternalMatchId = input.required<string>();
  gamePeriod = input<EGamePeriod>();

  selectedMatchTab = signal<EMatchTap>(EMatchTap.SUMMARY);

  handleHeaderTap(tabValue: EMatchTap) {
    this.selectedMatchTab.set(tabValue);
  }
}
